/**
 * Decides whether an OTP verify response may advance login or signup.
 *
 * verify.php's current success body includes `found`, and a login URL when
 * the phone already belongs to a customer. A proxy rewrite that only flips
 * `success` and the message text has neither, so it stays on the OTP step.
 * `otp_proof` is optional until the API starts returning one.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.KalkiOtpGuard = api;
  }
})(typeof window !== 'undefined' ? window : this, function () {
  var PROOF_PATTERN = /^[A-Za-z0-9_-]{32,256}$/;
  var FAILURE_MESSAGE = 'OTP verification failed. Please try again.';

  function isOtpProof(value) {
    return typeof value === 'string' && PROOF_PATTERN.test(value);
  }

  function isSuccessFlag(success) {
    return success === true || success === 1 || success === '1' || success === 'true';
  }

  function isFoundCustomer(found) {
    return found === true || found === 1 || found === '1' || found === 'true';
  }

  function normalizeHost(hostname) {
    return String(hostname || '').replace(/\.$/, '').toLowerCase();
  }

  function isAllowedLoginHost(hostname, options) {
    var host = normalizeHost(hostname);
    var settings = options || {};
    var pageHost = normalizeHost(settings.pageHostname);
    var allowedHosts = settings.allowedHosts || [];
    var index;
    if (!host || host.indexOf('.') === -1) return false;
    if (pageHost && host === pageHost) return true;
    for (index = 0; index < allowedHosts.length; index += 1) {
      if (host === normalizeHost(allowedHosts[index])) return true;
    }
    return host === 'kalkifashion.com' || host.slice(-17) === '.kalkifashion.com';
  }

  function isTrustedAccountLoginUrl(loginUrl, options) {
    var parsed;
    var trimmed;
    if (typeof loginUrl !== 'string') return false;
    trimmed = loginUrl.trim();
    if (trimmed.indexOf('https://') !== 0) return false;
    if (/[\s\\]/.test(trimmed)) return false;
    try {
      parsed = new URL(trimmed);
    } catch (error) {
      return false;
    }
    if (parsed.protocol !== 'https:') return false;
    if (parsed.username || parsed.password) return false;
    if (parsed.port && parsed.port !== '443') return false;
    if (parsed.pathname.indexOf('/') !== 0) return false;
    return isAllowedLoginHost(parsed.hostname, options);
  }

  function isUsableLoginUrl(loginUrl, options) {
    var trimmed;
    var lower;
    if (typeof loginUrl !== 'string') return false;
    trimmed = loginUrl.trim();
    if (!trimmed) return false;
    lower = trimmed.toLowerCase();
    if (lower.indexOf('javascript:') === 0 || lower.indexOf('data:') === 0 || lower.indexOf('vbscript:') === 0) return false;
    if (trimmed.indexOf('//') === 0 || trimmed.indexOf('\\') !== -1) return false;
    if (trimmed.charAt(0) === '/') return true;
    return isTrustedAccountLoginUrl(trimmed, options);
  }

  function acceptVerifyResponse(data, options) {
    var proof;
    var loginUrl;
    var hasFound;
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      return { ok: false };
    }
    if (!isSuccessFlag(data.success)) {
      return { ok: false };
    }
    proof = isOtpProof(data.otp_proof) ? data.otp_proof : '';
    loginUrl = typeof data.login_url === 'string' ? data.login_url.trim() : '';
    hasFound = Object.prototype.hasOwnProperty.call(data, 'found');
    if (isFoundCustomer(data.found)) {
      if (!isUsableLoginUrl(loginUrl, options)) {
        return { ok: false };
      }
      return {
        ok: true,
        kind: 'login',
        otpProof: proof,
        loginUrl: loginUrl
      };
    }
    if (hasFound) {
      return {
        ok: true,
        kind: 'signup',
        otpProof: proof
      };
    }
    if (isUsableLoginUrl(loginUrl, options)) {
      return {
        ok: true,
        kind: 'login',
        otpProof: proof,
        loginUrl: loginUrl
      };
    }
    return { ok: false };
  }

  function verificationFailureMessage(data) {
    if (data && data.success !== true && typeof data.message === 'string' && data.message.trim()) {
      return data.message;
    }
    return FAILURE_MESSAGE;
  }

  return {
    isOtpProof: isOtpProof,
    isTrustedAccountLoginUrl: isTrustedAccountLoginUrl,
    isUsableLoginUrl: isUsableLoginUrl,
    acceptVerifyResponse: acceptVerifyResponse,
    verificationFailureMessage: verificationFailureMessage
  };
});
